import { checkNull2String, getOnlyDate } from "./ItemTools"

export class ReqEmployeeResumeList {
    constructor({ companyId, start, limit, nickName, idNumber, jobStatus, departmentId }) {
        this.companyId = companyId
        this.start = start
        this.limit = limit
        if (nickName !== undefined && nickName !== "") {
            this.nickName = nickName
        }
        if (idNumber !== undefined && idNumber !== "") {
            this.idNumber = idNumber
        }
        if (jobStatus !== undefined && jobStatus !== "") {
            this.jobStatus = jobStatus
        }
        if (departmentId !== undefined && departmentId !== "") {
            this.departmentId = departmentId
        }
    }

    fromJson(jsonData) {
        // this.companyId = jsonData.companyId
        // this.start = jsonData.start
        // this.limit = jsonData.limit
        if (jsonData.nickName !== undefined)
            this.nickName = jsonData.nickName
        if (jsonData.idNumber !== undefined)
            this.idNumber = jsonData.idNumber
        if (jsonData.jobStatus !== undefined)
            this.jobStatus = jsonData.jobStatus
        if (jsonData.departmentId !== undefined)
            this.departmentId = jsonData.departmentId
    }
}

export class ReqEmployeeResumeCheck {
    constructor({ mobile, companyId }) {
        this.mobile = mobile
        this.companyId = companyId
    }

    fromJson(jsonDate) {
        this.mobile = jsonDate.mobile
        this.companyId = jsonDate.companyId
    }
}

export class ReqEmployeeResumeAdd {
    constructor({ companyId, accountId, idNumber, mobile, nickName, departmentId, roleId, base, creatAccountId, isAdd=true }) {
        this.companyId = companyId
        this.accountId = accountId
        this.idNumber = idNumber
        this.mobile = mobile
        this.nickName = nickName
        this.departmentId = departmentId
        this.roleId = roleId
        this.base = base
        this.creatAccountId = creatAccountId
        this.isAdd = isAdd
    }

    fromJson(jsonData) {
        if (jsonData !== undefined) {
            this.companyId = jsonData.companyId
            this.idNumber = jsonData.idNumber
            this.mobile = jsonData.mobile
            this.nickName = jsonData.nickName
            this.isAdd = jsonData.isAdd
        }
    }
}

export class ReqEmployeeResumeDetail {
    constructor({ companyId, accountId, tokenId }) {
        this.companyId = companyId
        this.accountId = accountId
        this.tokenId = tokenId
    }
}

export class RespEmployeeResumeDetail {
    constructor({ accountId = "", name="", companyName = "", departmentName = "", roleName = "", 
    employeeId = "", enrollDate="", resumeDatas = {}, creatAccountId = "", creatAt = "" }) {
        this.accountId = accountId
        this.name = name
        this.companyName = companyName
        this.departmentName = departmentName
        this.roleName = roleName
        this.employeeId = employeeId
        this.enrollDate = enrollDate
        this.resumeDatas = resumeDatas
        this.creatAccountId = creatAccountId
        this.creatAt = creatAt
    }
    setResumeData(key, val){
        if(this.resumeDatas === undefined){
            this.resumeDatas = {}
        }
        this.resumeDatas[key] = new ReqEmployeeResumeOtherData({})
        this.resumeDatas[key].fromJson(val)
    }

    fromJson(jsonData) {
        this.accountId = jsonData.accountId
        this.name = jsonData.name
        this.companyName = jsonData.companyName
        this.departmentName = jsonData.departmentName
        this.roleName = jsonData.roleName
        this.employeeId = jsonData.employeeId
        this.enrollDate = jsonData.enrollDate
        this.resumeDatas = jsonData.resumeDatas
        this.creatAccountId = jsonData.creatAccountId
        this.creatAt = jsonData.creatAt
    }
}

export class ReqEmployeeResumeOtherData {
    constructor({ accountId = "", accountKey = "" }) {
        this.accountId = accountId
        this.accountKey = accountKey
    }
}

export class RespEmployeeResumeOtherData {
    constructor({ accountId, accountKey, accountData, creatAccountId, creatAt }) {
        this.accountId = accountId
        this.accountKey = accountKey
        this.accountData = accountData
        if (creatAccountId !== undefined)
            this.creatAccountId = creatAccountId
        if (creatAt !== undefined)
            this.creatAt = creatAt

    }
}

/**
 * 內部員工基本資料
 */
export class RespEmployeeResumeOtherDataBase {
    constructor({ 
        idNumber = ""       //身分證
        , employeeId = ""   //員工編號(內部)
        , enrollDate = ""   //到職日(內部)
        , name = ""         //姓名
        , sex = ""          //性別
        , mobile = ""       //手機號碼
        , lineId = ""       //Line ID
        , birthday = ""     //生日
        , height = ""       //身高
        , weight = ""       //體重
        , marriage = ""     //婚姻狀態
        , military = ""     //兵役狀態
        , exMilitary = ""   //免役原因
        , residentialAddress = ""   //戶籍地址
        , mailingAddress = ""       //通訊地址
        , driverLicense = []        //駕照
        , transport = []            //交通工具
        , skills = []               //專長
        , otherSkill = ""           //其他專長
    }) {
        this.idNumber = idNumber
        this.employeeId = employeeId
        this.enrollDate = enrollDate
        this.name = name
        this.sex = sex
        this.mobile = mobile
        this.lineId = lineId
        this.birthday = birthday
        this.height = height
        this.weight = weight
        this.marriage = marriage
        this.military = military
        this.exMilitary = exMilitary
        this.residentialAddress = residentialAddress
        this.mailingAddress = mailingAddress
        this.driverLicense = driverLicense
        this.transport = transport
        this.skills = skills
        this.otherSkill = otherSkill
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

            console.log(jsonData)
            this.idNumber = checkNull2String(jsonData.idNumber) 
            this.name = checkNull2String(jsonData.name)
            this.sex = checkNull2String(jsonData.sex)
            this.mobile = checkNull2String(jsonData.mobile)
            this.lineId = checkNull2String(jsonData.lineId)
            this.birthday = checkNull2String(jsonData.birthday, getOnlyDate())
            this.height = checkNull2String(jsonData.height)
            this.weight = checkNull2String(jsonData.weight)
            this.marriage = checkNull2String(jsonData.marriage)
            this.military = checkNull2String(jsonData.military)
            this.exMilitary = checkNull2String(jsonData.exMilitary)
            this.residentialAddress = checkNull2String(jsonData.residentialAddress)
            this.mailingAddress = checkNull2String(jsonData.mailingAddress)
            this.driverLicense = jsonData.driverLicense !== undefined ? jsonData.driverLicense : []
            this.transport = jsonData.transport !== undefined ? jsonData.transport : []
            this.skills = jsonData.skills !== undefined ? jsonData.skills : []
            this.otherSkill = checkNull2String(jsonData.otherSkill)
            this.creatAccountId = checkNull2String(jsonData.creatAccountId)
            this.creatAt = checkNull2String(jsonData.creatAt)
    }
}
